import { render, staticRenderFns } from "./certificate-version.vue?vue&type=template&id=3eb2cab4&lang=pug&"
import script from "./certificate-version.vue?vue&type=script&lang=ts&"
export * from "./certificate-version.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports